<template>
	<b-row :class="(is_deleted ? 'archived-section' : '')">
		<b-col cols="12">
			<EsignDocuments />
			<ManualDocuments />
		</b-col>
	</b-row>
</template>

<script>
import EsignDocuments from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Documents/EsignDocuments'
import ManualDocuments from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Documents/ManualDocuments'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	components: {
		EsignDocuments,
		ManualDocuments
	},
	computed:{
		...mapState(useLoanCaseStore, ['activeCase']),
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		}
  },
}
</script>